import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { LoginData } from 'app/models/login-data';
import { AuthService } from 'app/services/auth.service';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {

  user: LoginData = new LoginData();
  showSpinner: boolean;
  error: string;

  constructor(private router: Router, private auth: AuthService) {
  }

  ngOnInit() {}

  onLogin(): void {
    this.showSpinner = true;
    this.error = '';
    this.auth.authentication(this.user)
      .subscribe(
        res => {
          this.router.navigate(['competition']);
          this.showSpinner = false;
        },
        error => {
          this.error = error;
          this.showSpinner = false;
        });
  }

  setRememberMe(): void {
   // this.user.rememberMe = !this.user.rememberMe;
  }

  openResetPassword(): void {}
}
